import { createAction } from '../../../store.model';
import { Sort } from '../../grid';
import { ActionType } from '../search.action';

export interface SortRows {
    options: Sort;
}

export const sortRows = createAction<ActionType, SortRows>(
    ActionType.EVAL_SEARCH__SORT_ROWS,
);
